import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { fmtMoney } from "@/pages/curated/shared";

export const WINDOWS = [[7, "7 días"], [30, "30 días"], [90, "90 días"], [0, "Todo"]];

export function WindowPicker({ value, onChange }) {
  return (
    <div className="flex gap-1" data-testid="curated-stats-window">
      {WINDOWS.map(([d, l]) => <Button key={d} size="sm" variant={value === d ? "default" : "outline"} onClick={() => onChange(d)} data-testid={`curated-stats-window-${d}`}>{l}</Button>)}
    </div>
  );
}

export function StatTiles({ s, currency }) {
  const tiles = [
    ["Visitas", s.views, `${s.visitors ?? 0} visitantes`], ["Abrieron «Reserve»", s.reserve_opens, `${s.rates?.reserve_open ?? 0} % de visitas`],
    ["Holds", s.holds, `${s.rates?.hold ?? 0} % de visitas`], ["Reservas pagadas", s.paid, `${s.seats_paid ?? 0} plazas`],
    ["Recaudado", fmtMoney(s.revenue || 0, currency || "USD"), `${s.devices?.mobile ?? 0} móvil · ${s.devices?.desktop ?? 0} escritorio`],
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-5" data-testid="curated-stats-tiles">
      {tiles.map(([l, v, sub]) => (
        <Card key={l}><CardContent className="p-4"><p className="text-xs uppercase tracking-wider text-muted-foreground">{l}</p><p className="mt-1 text-2xl font-semibold tabular-nums">{v ?? 0}</p><p className="text-xs text-muted-foreground">{sub}</p></CardContent></Card>
      ))}
    </div>
  );
}

export function DailyBars({ daily = [] }) {
  const max = Math.max(1, ...daily.map((d) => d.views));
  if (!daily.length) return <p className="text-sm text-muted-foreground" data-testid="curated-stats-nodata">Sin visitas registradas en este periodo.</p>;
  return (
    <div className="flex h-32 items-end gap-[2px]" data-testid="curated-stats-daily">
      {daily.map((d) => (
        <div key={d.day} className="group relative flex h-full flex-1 items-end" title={`${d.day} · ${d.views} visitas · ${d.reserve_opens} reserve · ${d.holds} holds`}>
          <div className="w-full rounded-t bg-primary/70 transition-colors group-hover:bg-primary" style={{ height: `${Math.max(2, (d.views / max) * 100)}%` }} />
          {d.holds > 0 && <div className="absolute inset-x-0 bottom-0 h-1 bg-emerald-500" />}
        </div>
      ))}
    </div>
  );
}

export function CuratedStatsTab({ trip }) {
  const [days, setDays] = useState(30);
  const { data, isLoading } = useQuery({ queryKey: ["curated-stats", trip.id, days], queryFn: async () => (await api.get(`/curated/${trip.id}/stats`, { params: { days } })).data });
  return (
    <div className="space-y-4" data-testid="curated-stats-tab">
      <div className="flex items-center justify-between"><p className="text-sm text-muted-foreground">Tráfico de la landing y embudo de reserva. Total histórico: {data?.views_total ?? "…"} visitas.</p><WindowPicker value={days} onChange={setDays} /></div>
      {isLoading || !data ? <Skeleton className="h-24 w-full" /> : (<>
        <StatTiles s={data} currency={trip.currency} />
        <Card><CardContent className="p-4"><p className="mb-3 text-xs uppercase tracking-wider text-muted-foreground">Visitas por día (verde = holds)</p><DailyBars daily={data.daily} /></CardContent></Card>
      </>)}
    </div>
  );
}
